export default {

    "userMenu": {
        "user": "Benutzer",
        "login": "Anmeldung",
        "overrideUser": "Benutzer wechseln",
        "settings": "Einstellungen",
        "revertUserOverride": "Zum Administrator zurückkehren",
        "administration": "Administration",
        "logout": "Abmeldung",

        "language": "Sprache",
        
        "resetUserSettings": {
            "menu": "Benutzereinstellungen zurücksetzen",
            "modalTitle": "Benutzereinstellungen zurücksetzen",
            "modalMessage": "Sie sind dabei, ALLE Ihre Benutzerdaten zurückzusetzen (letzte Abfragen, Ablagekörbe, Warnungen, Einstellungen usw.). Möchten Sie fortfahren?",
            "modalConfirmButton": "Bestätigen",
            "successMessage": "Benutzereinstellungen erfolgreich zurücksetzen",
            "errorMessage": "Benutzereinstellungen zurücksetzen fehlgeschlagen"
        },

        "darkMode": "Dunkelmodus",
        "darkModeOn": "Dunkelmodus deaktivieren",
        "darkModeOff": "Dunkelmodus einschalten",

        "credit": "Über Sinequa"
    },

    "editUserSettings": {
        "title": "Einstellungen",
        "language": "Sprache der Benutzeroberfläche",
        "pageSize": "Anzahl der Ergebnisse pro Seite",
        "email": "E-Mail"
    }

};
